/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WeeklyStatisticsModel } from '../../models/weekly-statistics-model';
import { WeeklyStatisticsRequestModel } from '../../models/weekly-statistics-request-model';

export interface ReportWeeklyStatisticsPost$Params {
  
    /**
     * Weekly statistics request with organization ID and date range.
     */
    body?: WeeklyStatisticsRequestModel
}

export function reportWeeklyStatisticsPost(http: HttpClient, rootUrl: string, params?: ReportWeeklyStatisticsPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<WeeklyStatisticsModel>> {
  const rb = new RequestBuilder(rootUrl, reportWeeklyStatisticsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<WeeklyStatisticsModel>;
    })
  );
}

reportWeeklyStatisticsPost.PATH = '/Report/WeeklyStatistics';
